import React from 'react'
import { ThemeProvider } from '@creditas/stylitas'
import { Global } from '@creditas/global'
import tokens from '@creditas/tokens'
import { BrowserRouter } from 'react-router-dom'
import { colorPalette } from 'shared/helpers/colorPalette'
import { ModalProvider, Router, ApplyTheme, DrawerProvider } from 'shared/ui'
import { AuthProvider } from 'shared/application/hooks/useAuthProvider.hook'
import { FeatureFlagsProvider } from 'shared/application/hooks/useFeatureFlag.hook'
import { ApolloProvider } from '@apollo/client'
import { apolloClient } from 'shared/infrastructure/clients'
import { Binds } from 'shared/infrastructure/binds/binds'

const App = () => (
  <AuthProvider>
    <FeatureFlagsProvider>
      <BrowserRouter>
        <ThemeProvider theme={{ ...tokens, ...colorPalette }}>
          <ApplyTheme>
            <ApolloProvider client={apolloClient}>
              <Global />
              <ModalProvider>
                <DrawerProvider>
                  {process.env.APP_ENV === 'production' && <Binds />}
                  <Router />
                </DrawerProvider>
              </ModalProvider>
            </ApolloProvider>
          </ApplyTheme>
        </ThemeProvider>
      </BrowserRouter>
    </FeatureFlagsProvider>
  </AuthProvider>
)

export { App }
